export interface DocRow {
  label: string;
  value: string;
}

export interface DocSection {
  title: string;
  rows: DocRow[];
}

export interface DocModel {
  title: string;
  sections: DocSection[];
}

export function convertJsonToDocModel(json: any): DocModel {

  return {
    title: json.title,
    sections: json.sections.map((s: any) => ({
      title: s.title,
      rows: s.table.body.map((r: string[]) => ({
        label: r[0],
        value: r[1]
      }))
    }))
  };

}